var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.3614 16.2595L14.7639 16.2595C14.2736 16.2595 13.8757 15.8616 13.8757 15.3713C13.8757 14.881 14.2736 14.4832 14.7639 14.4832L25.3614 14.4832C25.8516 14.4832 26.2495 14.881 26.2495 15.3713C26.2495 15.8616 25.8516 16.2595 25.3614 16.2595Z",
    fill: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_342_11531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 12,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6519 8.56079L15.6519 22.1813H4.47753L4.47753 8.56079L15.6519 8.56079Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_342_11531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7637 22.1816C14.5979 22.1816 14.4345 22.1355 14.29 22.0455L4.89212 16.1232C4.63396 15.9598 4.47646 15.6768 4.47646 15.3712C4.47646 15.0657 4.63396 14.7827 4.89212 14.6193L14.29 8.69704C14.5636 8.52533 14.9094 8.51467 15.1924 8.67217C15.4766 8.82849 15.6519 9.12572 15.6519 9.44901L15.6519 21.2935C15.6519 21.6168 15.4766 21.914 15.1924 22.0703C15.0586 22.1449 14.9105 22.1816 14.7637 22.1816Z",
    fill: "#1D1D1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.a7e057e4c91604cf63c62825eaa5e729.svg";
export { ForwardRef as ReactComponent };